import { v4 as uuid } from 'uuid';

import { VoiceboxProgressMessage } from 'src/utils/voicebox/types';

export const createProgressMessage = ({
  content,
}: {
  content: string;
}): VoiceboxProgressMessage => ({
  role: 'assistant',
  isProgress: true,
  content,
  id: uuid(),
});
